// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.booking-container {
  width: 100%;
  max-width: 576px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  padding: 20px 16px;
  padding-bottom: calc(20px + env(safe-area-inset-bottom));
  margin: 0 auto;
  flex: 1;
  min-height: 0;
  box-sizing: border-box;
}
.booking-container .booking-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  margin-top: 44px;
}
/*# sourceMappingURL=BookingPage.css.map */`, "",{"version":3,"sources":["webpack://./BookingPage.less","webpack://./src/containers/BookingPage/BookingPage.less"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,wDAAA;EACA,cAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;ACCD;ADZA;EAcE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;ACCF;AACA,0CAA0C","sourcesContent":[".booking-container {\n\twidth: 100%;\n\tmax-width: 576px;\n\tbackground-color: #ffffff;\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 20px 16px;\n\tpadding-bottom: calc(20px + env(safe-area-inset-bottom));\n\tmargin: 0 auto;\n\tflex: 1;\n\tmin-height: 0;\n\tbox-sizing: border-box;\n\n\t.booking-loading {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding: 60px 20px;\n\t\tmargin-top: 44px;\n\t}\n}\n",".booking-container {\n  width: 100%;\n  max-width: 576px;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  padding: 20px 16px;\n  padding-bottom: calc(20px + env(safe-area-inset-bottom));\n  margin: 0 auto;\n  flex: 1;\n  min-height: 0;\n  box-sizing: border-box;\n}\n.booking-container .booking-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 60px 20px;\n  margin-top: 44px;\n}\n/*# sourceMappingURL=BookingPage.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
